import axios from "axios";

export const updateProfile = async (payload) => {
  try {
    let status = await axios.put(
      `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/user/update`,
      payload
    );
    return status;
  } catch (err) {
    console.log("error while update user  profile in  keyclock", err.message);
    return {
      message: "Server Not responding! plese try after some time",
      status: 409,
    };
  }
};
